import type * as React from 'react';

function SvgRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M4 4h16v16H4z" />
        <path
          d="M16.22 12.694l-6.442 6.69a.822.822 0 01-1.163.023l-.022-.022a.887.887 0 010-1.231L14.519 12 8.593 5.846a.886.886 0 010-1.23.822.822 0 011.163-.023l.022.022 6.443 6.691a1 1 0 010 1.388z"
          fill="#00182E"
        />
      </g>
    </svg>
  );
}

export default SvgRight;
